import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export const DEFAULT_MAX_ITEMS = 8;
export const DEFAULT_SEPARATOR = NavigateNextIcon;
export const DEFAULT_ARIA_LABEL = 'breadcrumbs';
